<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "DualAxisLineChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], datasets: [] }),
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (!this.chartData || !this.chartData.labels || !this.chartData.datasets) return;

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext("2d");

      const datalabelsPlugin = {
        id: 'lineDatalabels',
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          chart.data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            meta.data.forEach((point, index) => {
              const value = dataset.data[index];
              if (value === 0 || value === null || value === undefined) return;

              ctx.save();
              ctx.fillStyle = dataset.borderColor || '#2e4664';
              ctx.font = 'bold 10px sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';

              // Format value: add % for churn rate (yAxisID === 'y1')
              const displayValue = dataset.yAxisID === 'y1'
                ? value.toFixed(1) + '%'
                : value;

              ctx.fillText(displayValue, point.x, point.y - 8);
              ctx.restore();
            });
          });
        },
      };

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.chartData.labels,
          datasets: this.chartData.datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              type: 'linear',
              display: true,
              position: 'left',
              beginAtZero: true,
              title: {
                display: true,
                text: 'Quantidade',
              },
            },
            y1: {
              type: 'linear',
              display: true,
              position: 'right',
              beginAtZero: true,
              title: {
                display: true,
                text: 'Churn %',
              },
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
        plugins: [datalabelsPlugin],
      });
    },
  },
};
</script>
